//https://github.com/redux-utilities/redux-actions
import { createActions, handleActions } from 'redux-actions'

const localStorageKey = 'appConfig'

const initialState = {
  geoLocalizacao: false,
  tamanhoMaximoSenha: 8,
  tamanhoMinimoSenha: 4
}
//o reducer começa assim
const defaultState = window.localStorage.getItem(localStorageKey) ? JSON.parse(window.localStorage.getItem(localStorageKey)) : initialState

//tem uma ação para salvar
export const { appConfigSave, appConfigReset  } = createActions({
   APP_CONFIG_SAVE: (value) => ({ value }),
   APP_CONFIG_RESET: () => ({  })
})

//função de salvar
export const appConfig = handleActions(
    {
      [appConfigSave]: (state, { payload: { value } }) => {
        console.log('------------:::::::::::::::', value)
        window.localStorage.setItem(localStorageKey, JSON.stringify(
            {
                geoLocalizacao: value.geoLocalizacao,
                tamanhoMaximoSenha: value.tamanhoMaximoSenha,
                tamanhoMinimoSenha: value.tamanhoMinimoSenha
            }
            ))
        return { 
            ...state, 
            geoLocalizacao: value.geoLocalizacao,
            tamanhoMaximoSenha: value.tamanhoMaximoSenha,
            tamanhoMinimoSenha: value.tamanhoMinimoSenha
        }
      },
      [appConfigReset]: (state) => {
        //console.log('------------', value)
        window.localStorage.removeItem(localStorageKey)
        return { 
            ...state, 
            geoLocalizacao: false,
            tamanhoMaximoSenha: 8,
            tamanhoMinimoSenha: 4
        }
      }
    },
    defaultState
  )